import { atom } from 'jotai';

import { inventoryPeriodDetailQueryAtom } from '../_graphql/queryInventoryPeriod';
import { inventoryPeriodBalancesQueryAtom } from '../_graphql/queryInventoryPeriodBalances';
import { inventoryPeriodTrialCloseQueryAtom } from '../_graphql/queryInventoryPeriodTrialClose';

import { atomFromRoutePath } from '~/shared/state';

export const $routeParams = atomFromRoutePath('/inventory/periods/:periodId');

export const $periodId = atom((get) => {
  const params = get($routeParams);
  return params.__didMatch ? params.periodId : undefined;
});

export const $remotePeriodDetail = inventoryPeriodDetailQueryAtom((get) => {
  const periodId = get($periodId);

  if (!periodId) {
    return {
      variables: {
        id: '',
      },
      skip: true,
    };
  }

  return {
    variables: {
      id: periodId,
    },
    skip: false,
  };
});

export const $remotePeriodBalances = inventoryPeriodBalancesQueryAtom((get) => {
  const periodId = get($periodId);

  if (!periodId) {
    return {
      variables: {
        inventoryPeriodId: '',
      },
      skip: true,
    };
  }

  return {
    variables: {
      inventoryPeriodId: periodId,
    },
    skip: false,
  };
});

export const $isLockDialogOpen = atom(false);

export const $remoteTrialClose = inventoryPeriodTrialCloseQueryAtom((get) => {
  const periodId = get($periodId);
  const isOpen = get($isLockDialogOpen);

  if (!periodId || !isOpen) {
    return {
      variables: {
        id: '',
      },
      skip: true,
    };
  }

  return {
    variables: {
      id: periodId,
    },
    skip: false,
  };
});
